import React, {useCallback, useRef, useState} from "react";

/**
 * Where the mouse is on the time axis, to show a line at the hovered time.
 * `trackRef` goes on the element that spans exactly the time axis (0 - 100%).
 */
const useTimelineHover = () => {
    const trackRef = useRef<HTMLDivElement>(null);
    /** Position of the mouse on the axis in percentages, `null` when outside of it. */
    const [hoverLeft, setHoverLeft] = useState<number | null>(null);

    const onMouseMove = useCallback((event: React.MouseEvent) => {
        const track: DOMRect | undefined = trackRef.current?.getBoundingClientRect();
        if (track === undefined || track.width === 0)
            return;

        const x: number = event.clientX - track.left;
        setHoverLeft(x < 0 || x > track.width ? null : x / track.width * 100);
    }, []);

    const onMouseLeave = useCallback(() => setHoverLeft(null), []);

    return {trackRef, hoverLeft, onMouseMove, onMouseLeave};
};

export default useTimelineHover;